import React, { Component, useState,useEffect  } from 'react';
import cookie from 'react-cookies';


class BABanner extends Component {
	constructor(props){
		super(props);
		this.state = {
			top: 1,
			bot: 6,
		}
	}


	loadNewData(){
		this.setState({
			top: Math.floor(Math.random() * (7 - 1 + 1) + 1)
		})
		this.setState({
			bot: Math.floor(Math.random() * (7 - 1 + 1) + 1)
		})

	}







	componentDidMount(){
		if(this.props.year.year ==2021){
			this.updateTimer = setInterval(() => this.loadNewData(), 5000);
		}

	}


	render(){
		const {top, bot} = this.state;
		const {year} = this.props;
		console.log(year.year)
		if (year.year ==2021){
			return(
				<div className="ba-top">
					<div className={"ba-topbg1 bg"+this.state.top}></div>
					<div className={"ba-topbg2 bg"+this.state.bot}></div>
					<div  className="balogo"><img src="/assets-2021/img/ba/logo.png"/></div>

				</div>
			)
		}else if (year.year ==2022){
			return(
				<div className="ba-top-nm">
					<img src="/assets-2021/img/ba/2022/bannerd.png" className="dbanner"/>
					<img src="/assets-2021/img/ba/2022/bannerm.png" className="mbanner"/>

				</div>
			)
		}else if (year.year == 2023){
			return (
				<div className="ba-top-nm">
					<img src="/assets-2021/img/ba/2023/bannerd.png" className="dbanner"/>
					<img src="/assets-2021/img/ba/2023/bannerm.png" className="mbanner"/>
				</div>
			)
		} else{
			return<div className="ba-top-nm">
				<img src="/assets-2021/img/ba/2022/bannerd.png" className="dbanner"/>
				<img src="/assets-2021/img/ba/2022/bannerm.png" className="mbanner"/>
			</div>
		}


	}
}

export default BABanner



// WEBPACK FOOTER //
// ./src/BABanner.js